'use client';

import * as React from 'react';
import type { LinkProps } from '@mui/material';
import Link from '@mui/material/Link';

export function NavLink({ children, ...props }: LinkProps) {
    return (
        <Link
            {...props}
            sx={{
                textDecoration: 'none',
                color: 'text.primary',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textTransform: 'uppercase',
                position: 'relative',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    width: 0,
                    height: (theme) => theme.spacing(0.25),
                    background: 'linear-gradient(90deg, var(--mui-palette-primary-main) 0%, var(--mui-palette-primary-dark) 100%)',
                    transition: '.3s all ease',
                },
                transition: (theme) =>
                    theme.transitions.create(['width', 'left'], {
                        duration: theme.transitions.duration.short,
                        easing: theme.transitions.easing.easeInOut,
                    }),
                '&:hover:after, &.active:after, &[aria-current="page"]:after': {
                    width: '100%',
                    left: 0,
                },
            }}
        >
            {children}
        </Link>
    );
}
